import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx'
import { UsersService } from './users.service'

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService:UsersService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):Observable<boolean> | boolean  {
       return this.authService.isAuthenticated()
        // return this.authService.isAuthenticated().map (
        //   authenticated => {
        //     if (authenticated) {
        //       console.log("authenticated")
        //       return authenticated
        //
        //     }else {
        //       console.log("go to signin")
        //       this.router.navigate(['/signin']);
        //       return authenticated
        //
        //     }
        //   },
        //   error => {
        //     return error
        //   }
        // )

        // not logged in so redirect to login page with the return url
        // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        // return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.guard.ts